import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { PageHeader, KPI, Card } from "@/components/Primitives";

export default function Reports() {
  const [m, setM] = useState(null);
  useEffect(() => { api.get("/reports/metrics").then((r) => setM(r.data)); }, []);
  if (!m) return <div className="p-8 text-zinc-500 text-xs">Loading…</div>;
  const cards = [
    ["Searches Run", m.searches_run],
    ["Candidates Found", m.candidates_found],
    ["Candidates Approved", m.candidates_approved],
    ["Candidates Imported", m.candidates_imported],
    ["Duplicates Avoided", m.duplicates_avoided],
    ["Expired Filtered", m.expired_filtered],
    ["Active Search Rules", m.active_search_rules],
    ["Open Tasks", m.open_tasks],
    ["Samples Requested", m.samples_requested],
    ["Samples Received", m.samples_received],
    ["Deliverables Pending", m.deliverables_pending],
    ["Production Delays", m.production_delays],
  ];
  return (
    <div>
      <PageHeader overline="Analytics" title="Reports & Metrics" sub="System-wide KPIs across discovery, qualification, suppliers, and production." />
      <div className="p-8 grid grid-cols-2 md:grid-cols-4 gap-3">
        {cards.map(([l, v]) => <KPI key={l} label={l} value={v} />)}
        <KPI label="Avg Fit Score" value={Number(m.avg_fit_score).toFixed(1)} accent />
      </div>
    </div>
  );
}
